export enum AdminCourseModeStatus {
	PROCTORED_ASSESSMENT = 'proctored_assessment',
	COURSE_QUIZ = 'course_quiz'
}


export const QUIZ_TYPE_LABEL_MAP: Record<AdminCourseModeStatus, string> = {
  [AdminCourseModeStatus.COURSE_QUIZ]: 'Course',
  [AdminCourseModeStatus.PROCTORED_ASSESSMENT]: 'Assessment'
};